import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsRoutesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LogisticsRouteDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.LogisticsRouteDocumentSortInput> | Types.LogisticsRouteDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsRoutesQuery = { __typename?: 'Query', logisticsRoutes?: { __typename?: 'LogisticsRoutesConnection', totalCount: number, nodes?: Array<{ __typename?: 'LogisticsRouteDocument', id: string, tenantId: string, routeId: string, code: string, name: string, description: string, isActive: boolean, isAdHoc: boolean, driverId?: string | null, defaultVehicleId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, stops: Array<{ __typename?: 'RouteStopData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type RouteStopDocumentFieldsFragment = { __typename?: 'RouteStopData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string };

export type LogisticsRouteDocumentFieldsFragment = { __typename?: 'LogisticsRouteDocument', id: string, tenantId: string, routeId: string, code: string, name: string, description: string, isActive: boolean, isAdHoc: boolean, driverId?: string | null, defaultVehicleId?: string | null, updatedAt: Types.TDateISO, updatedBy: string, stops: Array<{ __typename?: 'RouteStopData', routeStopId: string, customerLocationId?: string | null, customerName: string, address: string, latitude?: number | null, longitude?: number | null, mileage?: number | null, transitDays: number, notes: string }> };

export const RouteStopDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment RouteStopDocumentFields on RouteStopData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}
    `, {"fragmentName":"RouteStopDocumentFields"});
export const LogisticsRouteDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsRouteDocumentFields on LogisticsRouteDocument {
  id
  tenantId
  routeId
  code
  name
  description
  isActive
  isAdHoc
  driverId
  defaultVehicleId
  stops {
    ...RouteStopDocumentFields
  }
  updatedAt
  updatedBy
}
    fragment RouteStopDocumentFields on RouteStopData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}`, {"fragmentName":"LogisticsRouteDocumentFields"});
export const GetAllLogisticsRoutesDocument = new TypedDocumentString(`
    query GetAllLogisticsRoutes($where: LogisticsRouteDocumentFilterInput, $order: [LogisticsRouteDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsRoutes(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsRouteDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RouteStopDocumentFields on RouteStopData {
  routeStopId
  customerLocationId
  customerName
  address
  latitude
  longitude
  mileage
  transitDays
  notes
}
fragment LogisticsRouteDocumentFields on LogisticsRouteDocument {
  id
  tenantId
  routeId
  code
  name
  description
  isActive
  isAdHoc
  driverId
  defaultVehicleId
  stops {
    ...RouteStopDocumentFields
  }
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsRoutes: build.query<GetAllLogisticsRoutesQuery, GetAllLogisticsRoutesQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsRoutesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsRoutesQuery, useLazyGetAllLogisticsRoutesQuery } = injectedRtkApi;
